import styled from "styled-components/macro";
import InlineSVG from "react-inlinesvg";

const Container = styled.div`
  svg {
    path {
      fill: ${(props) => props.fillColor};
    }
  }
`;

function SVGIcon({ icon, alt, height, width, fillColor }) {
  return (
    <Container fillColor={fillColor}>
      <InlineSVG
        src={icon.src}
        aria-hidden="true"
        height={height}
        width={width}
      />
    </Container>
  );
}

export default SVGIcon;
